module.exports = __webpack_public_path__ + "static/cortex-value-change-min-cf533e0894d0ec951c14cd49ab65cc2d.png";